import React, { forwardRef, useCallback, useImperativeHandle } from 'react';
import classNames from 'classnames';
import SideDrawer from 'router/subrouters/DataRoom/components/SideDrawer';
import {
  SideDrawerProps,
  SideDrawerRef,
} from 'router/subrouters/DataRoom/components/SideDrawer/SideDrawer.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { useTranslation } from 'react-i18next';
import CreateIndexForm from './components/CreateIndexForm';
import { CreateIndexFormProps } from './components/CreateIndexForm/CreateIndexForm.component';

import './CreateIndexDrawer.styles.scss';
import { getArrayLength } from 'utils';

type CreateIndexDrawerProps = {
  className?: string;
} & CreateIndexFormProps &
  SideDrawerProps;

const CreateIndexDrawer: React.ForwardRefRenderFunction<
  SideDrawerRef,
  CreateIndexDrawerProps
> = (props, ref) => {
  const { className, buySideGroups, addArchive, ...rest } = props;

  const [drawer, drawerRef] = useCallbackRef<SideDrawerRef>(null);

  useImperativeHandle(ref, () => drawer, [drawer]);

  const classes = classNames('create-index-drawer', className);

  const { t } = useTranslation();

  const onClose = useCallback(() => drawer?.setOpen(false), [drawer]);

  return (
    <SideDrawer
      ref={drawerRef}
      className={classes}
      title={t(
        getArrayLength(buySideGroups)
          ? 'createDRIndexForBuyGroup'
          : 'generateFullDataRoom',
      )}
      {...rest}
    >
      <CreateIndexForm
        buySideGroups={buySideGroups}
        onClose={onClose}
        addArchive={addArchive}
      />
    </SideDrawer>
  );
};

export default forwardRef(CreateIndexDrawer);
